import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseSubMaintenanceController } from '../../_base/BaseSubMaintenanceController';
import { NotificationTopicSchemaPartnerUserItemMaintenanceDto } from './NotificationTopicSchemaPartnerUserItemMaintenanceDto';
import { NotificationTopicSchemaPartnerUserListMaintenanceDto } from './NotificationTopicSchemaPartnerUserListMaintenanceDto';

@Injectable()
export class NotificationTopicSchemaPartnerUserSubMaintenanceController extends BaseSubMaintenanceController<NotificationTopicSchemaPartnerUserListMaintenanceDto, NotificationTopicSchemaPartnerUserItemMaintenanceDto> {

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {

        super(http, alertService, translateService, loadingService, router, "partner/notificationtopicschemapartneruser");
    }

    public getResourceRoot(): string {
        return "NOTIFICATIONTOPICSCHEMAPARTNER.USER";
    }

    public buildUrl(parentId: number, optionParentid: string, uri: string): string {
        return "/system/partner/all/" + parentId + "/" + optionParentid + "/submain" + uri;
    }
}